import { Component, OnInit } from '@angular/core';
import { BaryComponentHelper } from '../../../../shared/util/bary-component-helper';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../models/bary-modal-event';
import { FormControl, FormGroup } from '@angular/forms';
import { ICustomer } from '../../../../../models/customer.model';
import { BasketOrder } from '../../../../../models/basket-order.model';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { UserTypology } from '../../../../../models/enums/user-typology.model';

@Component({
  selector: 'jhi-modal-customer-confirmation-differed-payment',
  templateUrl: './modal-customer-confirmation-differed-payment.component.html',
  styleUrls: ['./modal-customer-confirmation-differed-payment.component.scss'],
})
export class ModalCustomerConfirmationDifferedPaymentComponent implements OnInit {
  action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  customer!: ICustomer;
  basketorderList: BasketOrder[] | undefined;
  deferredBillsNoPaidAmountCumulated: number = 0;
  deferredBillsNoPaidBillnumbers: string = '';
  TRANSERT_DEFERRED = UserTypology.INIT_TRANSFERT_DEFERRED;
  controls!: {
    userTypology: FormControl;
  };
  baryForm!: FormGroup;

  constructor(private modalRef: MDBModalRef) {}

  handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  ngOnInit(): void {
    this.controls = {
      userTypology: new FormControl(this.TRANSERT_DEFERRED),
    };
    this.baryForm = new FormGroup(this.controls);
    if (this.basketorderList && this.basketorderList.length > 0) {
      this.deferredBillsNoPaidAmountCumulated = this.basketorderList.reduce((acc, currentValue) => acc + currentValue.price!, 0);
      this.basketorderList.forEach((its, idx) => {
        if (idx === (this.basketorderList || []).length - 1) {
          this.deferredBillsNoPaidBillnumbers += its.billNumber;
        } else {
          this.deferredBillsNoPaidBillnumbers += its.billNumber + ', ';
        }
      });
    }
  }

  submit(): void {
    this.action.next(new BaryModalEvent({ submit: true }));
    this.modalRef.hide();
  }

  handleSubmit(): void {
    if (this.baryForm.invalid) {
      this.baryForm.markAllAsTouched();
    } else {
      this.action.next(new BaryModalEvent({ submit: true, value: this.baryForm.value }));
      this.modalRef.hide();
    }
  }
}
